import { useState, useEffect } from 'react';
import {
  Grid,
  Button,
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import RttIcon from '@mui/icons-material/Rtt';

const ArrayFields = ({ data, onChange, title, error = false, name, defaultWord}) => {
  return (
    <Grid container spacing={2} alignItems='center'>
      {data.map((el, idx) => (
        <Grid item xs={3} key={`title-${idx}`}>
          <TextField
            error={error}
            label={title}
            value={el}
            fullWidth
            name={name ? `${name}[${idx}]` : title}
            onChange={(e) => {
              data[idx] = e.target.value;
              onChange(data);
            }}
            InputProps={{
              endAdornment: <InputAdornment position='end'>
                <IconButton
                  edge='end'
                  onClick={() => {
                    data[idx] = defaultWord;
                    onChange(data);
                  }}>
                  <RttIcon />
                </IconButton>
                <IconButton
                  edge='end'
                  onClick={() => {
                    data.splice(idx, 1);
                    onChange(data);
                  }}>
                  <DeleteIcon />
                </IconButton>
              </InputAdornment>
            }}
          />
        </Grid>
      ))}
      <Grid item xs={1}>
        <Button size='large' color={error ? 'error' : 'primary'} onClick={() => {
          data.push('');
          onChange(data);
        }}>
          <AddIcon />
          {data.length === 0 && title}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ArrayFields;
